export const D1_LOCAL_ENTRY_SERVICE_NAME = "d1:db:entry";
